import { getErrorFromFieldState } from '@utils/formHelpers';
import { memo } from 'react';
import { Control, FieldPath, FieldValues, useController, useFormContext } from 'react-hook-form';
import { BlockInputField, BlockInputFieldProps } from './BlockInputField';

type RHFBlockInputFieldProps<TFieldValues extends FieldValues = FieldValues> = Omit<
  BlockInputFieldProps,
  'value' | 'onChange' | 'error' | 'name'
> & {
  name: FieldPath<TFieldValues>;
  control?: Control<TFieldValues>;
};

const RHFBlockInputFieldInner = <TFieldValues extends FieldValues = FieldValues>({
  name,
  control: controlProp,
  ...props
}: RHFBlockInputFieldProps<TFieldValues>) => {
  const formContext = useFormContext<TFieldValues>();
  const control = controlProp ?? formContext?.control;

  const {
    field: { onChange, value, ref },
    fieldState: { error },
  } = useController({ name, control });

  return (
    <BlockInputField
      {...props}
      name={name}
      value={value}
      onChange={onChange}
      error={getErrorFromFieldState(error)}
      innerRef={ref}
    />
  );
};

export const RHFBlockInputField = memo(RHFBlockInputFieldInner) as typeof RHFBlockInputFieldInner;
